import React, { useMemo } from "react";
import { ThemeProvider as Provider } from "styled-components";

import { useTheme } from "../../hooks/useTheme";
import { usePublicConfig } from "../../hooks/usePublicConfig";
import { SHOPIFY_ENV } from "../../utils";
import { testTheme } from "../../theme/testTheme";
import { shopifyTheme } from "../../theme/shopifyTheme";
import { mainTheme } from "../../theme/mainTheme";

const ThemeProvider = ({ children }) => {
  const { theme } = useTheme();
  const { env } = usePublicConfig();

  const userTheme = useMemo(() => {
    if (theme === "testTheme") {
      return shopifyTheme;
    }

    if (SHOPIFY_ENV.includes(env?.hostEnv)) {
      return shopifyTheme;
    }

    return mainTheme;
  }, [theme, env?.hostEnv]);

  return <Provider theme={userTheme}>{children}</Provider>;
};

export default ThemeProvider;
